import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FsxButtonComponent, FsxButtonTypeEnum } from 'fsx-component-library';
import { VersionCheckService } from '../../services/version-check/version-check.service';

/**
 * A dismissable-by-refresh banner shown when a newer build has been deployed while
 * this tab is still open. Prompts the user to reload on their own terms, heading off
 * a stale-tab chunk-load error before it happens (see {@link VersionCheckService}).
 */
@Component({
  selector: 'app-update-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FsxButtonComponent],
  templateUrl: './app-update-banner.component.html',
  styleUrls: ['./app-update-banner.component.scss'],
})
export class AppUpdateBannerComponent {
  /** True once a newer deployed build is available. */
  protected readonly updateAvailable = inject(VersionCheckService).updateAvailable;

  /** Button type enum for the refresh action. */
  protected readonly FsxButtonTypeEnum = FsxButtonTypeEnum;

  /** Reloads the page to pick up the newer build. */
  protected onRefreshClicked(): void {
    window.location.reload();
  }
}
